module.exports = __webpack_public_path__ + "img/business_ojigi_woman.098116eb.png";